import { defineFcm } from '../shared/factory';

export const FCM_SAP_CTA_ON_PETITION_SHOW = defineFcm('sap_cta_on_petition_show')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description:
			'Indicates whether to display a SAP CTA button under the petition description, for users that have signed the petition.',
		import: false,
	});
